import { Answer, Question, QuestionnaireService } from "@/types/questionnaire";
import { useState } from "react";
import parse from 'html-react-parser';
import BaseCheckbox from "./BaseCheckbox";

interface Properties {
    question: Question,
    title?: string,
    description?: string
    setQuestionCompleted: (isComplete: boolean) => void;
}

function QuestionCheckboxComponent(properties: Properties) {
    const question: Question = properties.question;
    const selected: number = question.answers.reduce((prev: number, curr: Answer) => prev + (curr.checked ? 1 : 0), 0);
    
    const [checkedAnswers, setCheckedAnswers] = useState<number>(selected);

    const onClickCheckbox = (answerId: number) => {
        // flip the checked state - NOTE: this alone does not change state, thus does not render
        const answer: Answer = properties.question.answers[answerId];
        answer.checked = !answer.checked;

        // determine if this question can now be marked as completed
        const newValue: number = checkedAnswers + (answer.checked ? 1 : -1);
        setCheckedAnswers(newValue);
        // no need to do this, previous state change forces a recalc, en thus updates questionCompleted value
        properties.setQuestionCompleted(newValue > 0);
    }

    const title: string = properties.title ?? question.title;
    const description: string = properties.description ?? question.description ?? "Kies 1 of meerdere antwoorden";

    return (
        <>
            <h4>{title}</h4>
            { description.length > 0 && (<p className="text-lg mt-2">{ description }</p>)}
            <div className="mt-3 space-y-0 overflow-auto flex-initial">
                {question.answers.map((answer: Answer, index: number) => {
                    return (
                        <label
                            className={`flex-1 flex flex-row pt-2 pb-2 gap-3 bg-white text-xl items-center cursor-pointer`}
                            key={answer.id}
                        >
                            <BaseCheckbox
                                className="cursor-pointer"
                                checked={answer.checked}
                                onChange={() => onClickCheckbox(index)}
                            />
                            <h5 className="flex-1 text-xl font-normal">{ parse(QuestionnaireService.AnswerGetContent(answer)) }</h5>
                        </label>
                    )}
                )}
            </div> 
        </>
    )
}

export default QuestionCheckboxComponent;